import { createFileRoute } from '@tanstack/react-router';
import EditPermissionPageComponent from 'src/Administration/EditPermisionGroupPage/EditPermisionGroupPage';

export const Route = createFileRoute('/systemadmin/_layout/groups/edit/$id')({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  console.log('[GroupEditRoute] Rendering with id:', id);
  return <EditPermissionPageComponent id={id} />;
}
